import React, { useMemo } from 'react';
import { createBrowserHistory } from 'history';
import { Redirect, Router, Route, Switch } from 'react-router-dom';

import { navigableRoutes, internalRoutes } from './routes';

import AdminLayout from './layouts/Admin';

import Login from 'views/Login';
import Password from 'views/Password';
import PasswordNM from 'views/NoMatriculados/Password';
import Registration from 'views/NoMatriculados/Registration';

import UserContext from './context/UserContext';
import StoreProvider from './context/StoreContext';
import ConfigContext from './context/ConfigContext';

import './App.css';

const browserHistory = createBrowserHistory();

function App() {
  const layoutPaths = useMemo(() => {
    return Array.from(
      new Set(
        [...navigableRoutes, ...internalRoutes]
          .map(route => route.path.split('/')[1])
          .filter(Boolean)
          .map(prefix => `/${prefix}`),
      ),
    );
  }, []);

  return (
    <StoreProvider>
      <UserContext>
        <ConfigContext>
          <Router history={browserHistory}>
            <Switch>
              <Route path="/login" render={() => <Login />} />
              <Route path="/password-nm" render={() => <PasswordNM />} />
              <Route path="/password" render={() => <Password />} />
              <Route path="/registration" render={() => <Registration />} />

              <Route path={layoutPaths}>
                <AdminLayout />
              </Route>

              {/* Cualquier ruta no reconocida redirige a login */}
              <Route render={() => <Redirect to="/login" />} />
            </Switch>
          </Router>
        </ConfigContext>
      </UserContext>
    </StoreProvider>
  );
}

export default App;
